<template>
    <span>
        <span class="dot dot1">.</span>
        <span class="dot dot2">.</span>
        <span class="dot dot3">.</span>
    </span>
</template>

<script>
export default {
    name: "BlinkingDots"
}
</script>

<style scoped>
.dot {
    animation: blink 1.5s infinite;
}

.dot1 {
    animation-delay: 0s;
}

.dot2 {
    animation-delay: 0.5s;
}

.dot3 {
    animation-delay: 1s;
}

@keyframes blink {
    0%, 100% {
        opacity: 0;
    }
    50% {
        opacity: 1;
    }
}
</style>